import {User} from '@exp1/common-utils'
import {axiosInstance} from './getInstance'

export const iAm = async (): Promise<User> => {
  const response = await axiosInstance.post<User>('/api/app/iam')
  return response.data
}
